import { LogoutAppService } from '../../shared/service/comunicator-native/logout-app/logout-app';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title, SafeHtml } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { AnalycticsNativeService } from '../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { AnalyticsPageService } from '../../shared/service/analytics/analytics-page.service';
import { AnalyticsPageModel } from '../../shared/model/analyticsPage';
import { Term } from '../../shared/service/terms/model/term.model';
import { TermsFactoryService } from '../../shared/service/terms/terms-factory-service';
import { DataOrigin } from '../../shared/model/DataOrigin';
import { UserNewFactoryService } from '../../shared/service/user-new/usernew-factory-service';
import { CacheNativeFistAccessService } from '../../shared/service/comunicator-native/cache-first-access/cache-native-first-access';
import { platform } from '@ids/tools';
import { AnalyticsGA4PageService } from '../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';

@Component({
  selector: 'app-first-access-screen',
  templateUrl: './first-access-screen.component.html',
  styleUrls: ['./first-access-screen.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FirstAccessScreenComponent implements OnInit {

  private readonly HEADER_ID = 'first-access-screen';
  private readonly TITLE_PAGE = 'Primeiro acesso';

  titleContent: string;
  description: SafeHtml;
  analyticsPage: AnalyticsPageModel;
  loadingVerify = false;
  alertVoiceOver = false;
  loading = false;
  dataOrigin = DataOrigin.Mobile;
  idLink = 'btn-termo-uso';
  idTitleContent = 'title-content';
  sentData = false;
  listTerms: Term[] = [
    {
      title: 'Termos de uso e política de privacidade',
      type: 'USOEPOLITICADEPRIVACIDADE_LOCAL'
    },
  ];
  labelBtnBack = 'voltar';
  templateError = false;
  focusBtnHeaderError = false;
  showBtnTryAgain = true;
  ariaLabelPage = true;

  private analyticsGA4PagesModel: AnalyticsGA4PagesModel;

  constructor(
    public router: NavController,
    private title: Title,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private termsFactoryService: TermsFactoryService,
    private userNewFactoryService: UserNewFactoryService,
    private cacheNativeFistAccessService: CacheNativeFistAccessService,
    private logoutAppService: LogoutAppService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.focusPage(`#${this.HEADER_ID}`, 60);
  }

  ionViewWillEnter() {
    this.focusPage(`#${this.HEADER_ID}`, 60);
    this.showTemplateError();
    this.sendTrackGA4LoadPage(this.analyticsGA4PagesModel.customAceitarTermosUso);
  }

  showTemplateError() {
    if (this.sentData) {
      this.setStateRetry();
      this.showBtnTryAgain = false;
    }
  }

  focusPage(selector: string, time: number) {
    if (platform.os === 'IOS') {
      document.body.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        document.body.removeAttribute('aria-hidden');
        this.focusElement(selector, time);
      }, 300);
    } else {
      this.focusElement(selector, time);
    }
  }

  getAnalyticsPageGA4() {
    this.analyticsGA4PagesModel = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  sendTrackGA4LoadPage(customPath: string) {
    const paramDefautl = {
      event_name: this.analyticsGA4PagesModel.eventNameScreenView,
      custom_path: customPath,
      implementation_team: this.analyticsGA4PagesModel.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  focusElement(selector: string, time: number) {
    setTimeout(() => {
      const element = (document.querySelector(selector) as HTMLElement);
      element?.focus();
    }, time);
  }

  setTitle() {
    this.title.setTitle(this.TITLE_PAGE);
  }

  getPageId(): string {
    return this.HEADER_ID;
  }

  clickNext() {
    this.sendUserData();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage?.enterData;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  openDetail(item: any) {
    this.ariaLabelPage = true;
    this.router.navigateForward('details', {
      state: {
        data: item,
      }
    });
    this.sendTrackGA4LoadPage(this.analyticsGA4PagesModel.customAceitarTermosUsoTermos);
  }

  getTerm(item: any) {
    const termHasDescription: Term[] = this.listTerms.filter((term: Term) => term?.description && term.type === item.type);
    if (termHasDescription.length > 0) {
      this.openDetail({
        ...termHasDescription[0],
        title: termHasDescription[0].titleContent,
        index: item.index
      });
    } else {
      this.loading = true;
      this.termsFactoryService.getService(this.dataOrigin).getTerms('uso').then((term: Term) => {
        if (term) {
          const termDescription = term?.description.split('\r\n')
            .filter((str: string) => str.replace(/\s/g, '') !== '').map((str: string) => {
              if (str.includes('_____________________')) {
                return `<p class='bar'>${str}</p>`;
              }
              return `<p>${str}</p>`;
            }).join('');
          this.updateLisTerms(item.type, { ...term, description: termDescription });
          this.loading = false;
          this.openDetail({
            ...term,
            titleContent: term.title,
            description: termDescription,
            index: item.index,
            pageLoadedOnlyScreenReader: true
          });
        }
      })
        .catch(() => this.loading = false);
    }
  }

  updateLisTerms(type: string, term: Term) {
    this.listTerms.forEach(element => {
      if (element.type === type) {
        element.titleContent = term.title
        element.description = term.description
      }
      return element;
    });
  }

  sendUserData() {

    if (!this.sentData) {
      this.loadingVerify = true;
      this.showAlertVoiceOver();
      this.focusBtnHeaderError = false;

      this.userNewFactoryService.getService(this.dataOrigin).postUserNew()
        .then((data: any) => {
          this.sentData = true;
          if (data?.errorData?.data?.statuscode !== undefined) {
            this.setStatusErrorPost();
          } else {
            this.cacheNativeFistAccessService.getItemCommunicator();
          }
        })
        .catch(() => {
          this.setStatusErrorPost();
        });
    }
  }

  setStatusErrorPost() {
    this.setStateRetry();
    this.sentData = false;
  }

  setStateRetry() {
    this.loadingVerify = false;
    this.templateError = true;
    this.focusBtnHeaderError = true;
  }

  showAlertVoiceOver() {
    if (platform.os === 'Android') {
      this.alertVoiceOver = true;
      setTimeout(() => this.alertVoiceOver = false, 1000);
    }
  }

  logout() {
    this.logoutAppService.returnCommunicator();
  }

}
